import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchKnowTheEntitySection } from "../../../../services/knowTheHost.service";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import {
  SECTION_KNOW_THE_HOST_COMPONENTS,
  STD_ERROR_MESSAGE,
} from "../../../../utils/constant.js";
import AddTestimonial from "../../add-testimonial/AddTestimonial";
import Testimonial from "../../testimonial/Testimonial";
import { fetchTestimonial } from "../../../../services/testimonial.service";
import KnowTheEntity from "../../know-the-entity/KnowTheEntity";

const SectionTestimonial = (props) => {
  const [loading, setLoading] = useState(true);
  const testimonialState = useSelector((state) => state.testimonialAd);
  const dispatch = useDispatch();
  const params = useParams();

  const [currentMainComponent, setCurrentMainComponent] = useState({
    currComponent: null,
    prevComponent: null,
  });
  useEffect(() => {
    if (isEmpty(testimonialState.response)) {
      dispatch(fetchTestimonial(params.entityId));
    }
  }, []);

  useEffect(() => {
    if (!testimonialState.loading && !isEmpty(testimonialState.response)) {
      if (!isEmpty(testimonialState.response.data)) {
        setCurrentMainComponent((prevState) => {
          return {
            currComponent:
              SECTION_KNOW_THE_HOST_COMPONENTS.list_know_the_host_sections,
            prevComponent: prevState.component,
          };
        });
      } else {
        setCurrentMainComponent((prevState) => {
          return {
            currComponent:
              SECTION_KNOW_THE_HOST_COMPONENTS.add_know_the_host_sections,
            prevComponent: prevState.component,
          };
        });
      }
      setLoading(false);
    }
    if (!testimonialState.loading && !isEmpty(testimonialState.error)) {
      setLoading(false);
      toast.error(
        testimonialState.error?.data?.error_data || STD_ERROR_MESSAGE
      );
    }
  }, [testimonialState]);
  function getMainComponent() {
    switch (currentMainComponent.currComponent) {
      case SECTION_KNOW_THE_HOST_COMPONENTS.add_know_the_host_sections:
        return (
          <AddTestimonial
            setCurrentMainComponent={setCurrentMainComponent}
            currentMainComponent={currentMainComponent}
          />
        );
      case SECTION_KNOW_THE_HOST_COMPONENTS.list_know_the_host_sections:
        return (
          <Testimonial
            setCurrentMainComponent={setCurrentMainComponent}
            currentMainComponent={currentMainComponent}
          />
        );
      default:
        return null;
    }
  }
  return <>{!loading ? getMainComponent() : null}</>;
};
export default SectionTestimonial;
